import { LocationsList } from '@ui/location/locations-list';
import { useCities } from '../../../entites/city';

export const Locations = ({
  query,
  className,
  isDivided,
  onSelect,
}: {
  query: string;
  className?: string;
  isDivided?: boolean;
  onSelect?: (key: string) => void;
}) => {
  const { data, onCitySelect, selectedCity } = useCities({ query });
  return (
    <LocationsList
      className={className}
      items={data}
      isDivided={isDivided}
      onSelect={(key) => {
        onCitySelect(key);
        onSelect?.(key);
      }}
      value={selectedCity}
    />
  );
};
